import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";
import filters from "../services/filters";
import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    active: {
      users: [],
      campaigns: null,
      exitStrategies: 0,
      temperatures: null,
      dealProbabilityScore: null,
      timeFrames: 0,
      deals: 0,
    },
  },
  records: [],
  pipelineViewId: null,
});

const getters = {
  records(state, getters, rootState, rootGetters) {
    let records = state.records;
    let view = rootGetters["pipeline/selectedPipelineView"];

    if (view) {
      records = records.filter(record => view.status_ids.includes(record.current_status_id));
    }

    records = filters.byUsers(records, state.filters.active.users);
    records = filters.byCampaigns(records, state.filters.active.campaigns);
    records = filters.byExitStrategy(records, state.filters.active.exitStrategies);
    records = filters.byTemperature(records, state.filters.active.temperatures);
    records = filters.byDealProbabilityScore(records, state.filters.active.dealProbabilityScore);
    records = filters.byTimeframe(records, state.filters.active.timeFrames);
    records = filters.byDeal(records, state.filters.active.deals);

    records.sort((a,b) => {
      if (! a.nextTask) return 0

      if (! b.nextTask) return -1

      return new Date(a.nextTask.due_at) - new Date(b.nextTask.due_at)
    })

    return records;
  },
  recordsByStatusId: (state, getters) => (statusId) => {
    return getters.records.filter(record => record.current_status_id === statusId);
  },
  pipelineViewId(state, getters) {
    // trigger to reload active pipeline if the value changes
    return state.pipelineViewId
  },
};

const mutations = {
  setup(state, data) {
    state.records = [...state.records, ...data.records];
  },
  teardown(state) {
    state.records = [];
  },
  setOneFilter(state, [filterObject, filter, value]) {
    state.filters[filterObject][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  resetFilters(state, filterObject) {
    // Make sure to update state default
    state.filters[filterObject] = {
      users: [],
      campaigns: null,
      exitStrategies: 0,
      temperatures: null,
      dealProbabilityScore: null,
      timeFrames: 0,
      deals: 0,
    };

    store.dispatch('updateUserAppFilter')
  },
  setPipelineViewId(state, viewId) {
    state.pipelineViewId = viewId
  },
};

const actions = {
  setup({commit, state, rootState, getters}, statusId) {
    subscribeToChannel("activeState", rootState.market.market.id);

    return api.clientStore.initActiveState(rootState.market.market.id, statusId).then(response => {
      commit('setup', response.data);
    });
  },
  tearDown({commit, state, rootState, getters}) {
    unsubscribeToChannel("activeState", rootState.market.market.id);
    commit('teardown')
  },
};

const ActiveStateStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ActiveStateStore;
